import StarterKit from "./StarterKit";

import HeaderFull from "./components/HeaderFull";
// import HeaderBurger from "./components/HeaderBurger";

import BlockBanner from "./blocks/BlockBanner";
// import BlockCollapse from "./blocks/BlockCollapse";
import BlockGallery from "./blocks/BlockGallery";
import BlockGallerySlider from "./blocks/BlockGallerySlider";
// import BlockMap from "./blocks/BlockMap";
import BlockMovie from "./blocks/BlockMovie";
// import BlockQuotes from "./blocks/BlockQuotes";
import BlockSlider from "./blocks/BlockSlider";
// import BlockSliderScrollable from "./blocks/BlockSliderScrollable";
// import BlockScrollingText from "./blocks/BlockScrollingText";
import Sidebar from "./components/Sidebar";
import BlockTableLot from "./blocks/BlockTableLot";
import SogepromUTM from "./components/SogepromUtm";

document.addEventListener("DOMContentLoaded", function () {
	// Starterkit
	StarterKit.init();

	// Components
	HeaderFull.init();
	// HeaderBurger.init();

	// Blocks
	BlockBanner.init();
	// BlockCollapse.init();
	BlockGallery.init();
	BlockGallerySlider.init();
	// BlockMap.init();
	BlockMovie.init();
	// BlockQuotes.init();
	BlockSlider.init();
	// BlockScrollingText.init();
	// BlockSliderScrollable.init();

	Sidebar.init();
	BlockTableLot.init();
	SogepromUTM.init();
});
